import { useState } from "react"
import { FaStar, FaRegStar, FaRegEdit, FaInfoCircle } from "react-icons/fa"
import TextAreaEditor from "../../../../components/Form/TextAreaEditor";

// import React, { useState } from "react";
// import { FaStar, FaRegStar, FaRegEdit, FaInfoCircle } from "react-icons/fa";
import axios from "axios"; // Assurez-vous d'importer axios pour l'appel API
// import TextAreaEditor from "./TextAreaEditor"; // Assurez-vous que votre TextAreaEditor est bien défini

const ReviewCard = ({ application }) => {
  const [rating, setRating] = useState(application.score || 0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState(application.comment || "");

  const handleRating = (index) => {
    setRating(index + 1);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post("/api/saveReview", {
        applicationId: application.id,
        rating: rating,
        comment: comment,
      });

      if (response.status === 200) {
        alert("Évaluation soumise avec succès!");
      } else {
        alert("Une erreur est survenue.");
      }
    } catch (error) {
      console.error("Erreur lors de la soumission de l'évaluation: ", error);
      alert("Une erreur est survenue.");
    }
  };

  return (
    <div className="space-y-4">
      {/* Evaluation / Note */}
      <div className="bg-white p-4 rounded-lg shadow">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-lg">Évaluation du Candidat</h3>
          <FaRegEdit className="text-gray-500 cursor-pointer" />
        </div>
        <p className="text-gray-500 text-sm">
          Il s'agit de l'évaluation attribuée au candidat en fonction de ses qualifications et performances.
        </p>
        <div className="mt-3 flex items-center space-x-2">
          <span className="font-bold">{application.score}</span>
          {[...Array(5)].map((_, index) => (
            <FaStar key={index} className={index < application.score / 20 ? "text-yellow-400" : "text-gray-300"} />
          ))}
        </div>
        <p className="text-gray-600 text-sm mt-1">{application.note}</p>
        <div className="flex items-center space-x-2 mt-2">
          <img src="https://i.pravatar.cc/30" alt="avatar" className="w-6 h-6 rounded-full" />
          <span className="text-sm text-gray-500">{application.user_id} • {new Date(application.created_at).toLocaleString()}</span>
        </div>
      </div>

      {/* Commentaires sur l'évaluation */}
      <div className="bg-white p-4 rounded-lg shadow">
        <h3 className="font-semibold text-lg">Commentaires</h3>
        <p className="text-gray-500 text-sm">
          Vous pouvez ajouter des commentaires sur cette évaluation, comme des points forts ou des améliorations possibles.
        </p>
        <div className="flex my-2">
          {[...Array(5)].map((_, index) => (
            <button
              key={index}
              onMouseEnter={() => setHover(index + 1)}
              onMouseLeave={() => setHover(0)}
              onClick={() => setRating(index + 1)}
            >
              {index < (hover || rating) ? (
                <FaStar className="text-yellow-400 text-xl" />
              ) : (
                <FaRegStar className="text-gray-400 text-xl" />
              )}
            </button>
          ))}
        </div>
        
        {/* Comment Box */}
        <div className="mt-4">
          <label className="text-sm font-semibold">Commentaires</label>
          <TextAreaEditor
            placeholder="Tapez vos commentaires ici"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        {/* Boutons */}
        <div className="flex justify-end space-x-2 mt-4">
          <button className="text-gray-600">Annuler</button>
          <button className="bg-gray-800 text-white px-4 py-2 rounded-lg">Envoyer l'évaluation</button>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;


// const ReviewCard = () => {
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [comment, setComment] = useState("");

//   return (
//     <div className=" space-y-4">
//       {/* Relevant Education */}
//       <div className="bg-white p-4 rounded-lg shadow">
//         <div className="flex justify-between items-center">
//           <h3 className="font-semibold text-lg">Relevant Education</h3>
//           <FaRegEdit className="text-gray-500 cursor-pointer" />
//         </div>
//         <p className="text-gray-500 text-sm">
//           Refers to the academic background and certifications that a candidate possesses.
//         </p>
//         <div className="mt-3 flex items-center space-x-2">
//           <span className="font-bold">3</span>
//           {[...Array(5)].map((_, index) => (
//             <FaStar key={index} className={index < 3 ? "text-yellow-400" : "text-gray-300"} />
//           ))}
//         </div>
//         <p className="text-gray-600 text-sm mt-1">Candidate education is relevant to this job.</p>
//         <div className="flex items-center space-x-2 mt-2">
//           <img src="https://i.pravatar.cc/30" alt="avatar" className="w-6 h-6 rounded-full" />
//           <span className="text-sm text-gray-500">Bagus Fikri • 2h ago</span>
//         </div>
//       </div>

//       {/* Research Experience */}
//       <div className="bg-white p-4 rounded-lg shadow">
//         <h3 className="font-semibold text-lg">Research Experience</h3>
//         <p className="text-gray-500 text-sm">
//           Refers to the candidate's practical involvement in research activities.
//         </p>
//         <div className="mt-3 flex items-center space-x-2">
//           <span className="font-semibold">Rating Score</span>
//           <FaInfoCircle className="text-gray-400" />
//         </div>
        // <div className="flex mt-2">
        //   {[...Array(5)].map((_, index) => (
        //     <button
        //       key={index}
        //       onMouseEnter={() => setHover(index + 1)}
        //       onMouseLeave={() => setHover(0)}
        //       onClick={() => setRating(index + 1)}
        //     >
        //       {index < (hover || rating) ? (
        //         <FaStar className="text-yellow-400 text-xl" />
        //       ) : (
        //         <FaRegStar className="text-gray-400 text-xl" />
        //       )}
        //     </button>
        //   ))}
        // </div>

//         {/* Comment Box */}
//         <div className="mt-4">
//           <label className="text-sm font-semibold">Comments</label>
//           <TextAreaEditor
//             placeholder="Type your comment here"
//             value={comment}
//             onChange={(e) => setComment(e.target.value)}
//           />
          
//         </div>

//         {/* Buttons */}
//         <div className="flex justify-end space-x-2 mt-4">
//           <button className="text-gray-600">Cancel</button>
//           <button className="bg-gray-800 text-white px-4 py-2 rounded-lg">Submit</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReviewCard;
